import React from 'react';
export function PainPointsSection() {
  const painPoints = ['Domingo a la noche buscando actividades que nunca quedan como querés', 'Clases improvisadas porque no tenés secuencia ni estructura armada', 'Evaluaciones inventadas porque no tenés criterios ni rúbricas listos', 'Horas perdidas buscando problemas, consignas y ejercicios sueltos', 'Planificaciones que hacés de apuro y nunca reflejan lo que realmente das'];
  return <section className="bg-brand-dark py-16 md:py-24 px-4 border-t border-brand-border" data-id="element-177">
      <div className="max-w-3xl mx-auto" data-id="element-178">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-white text-center mb-10 md:mb-14 leading-snug px-2" data-id="element-179">
          Si sos docente de Matemática en primaria o secundaria,
          <br data-id="element-180" />
          <span className="text-brand-accent" data-id="element-181">
            esto te va a sonar familiar:
          </span>
        </h2>
        <div className="space-y-4 md:space-y-5 mb-14 md:mb-16" data-id="element-182">
          {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 md:gap-5 py-5 md:py-6 px-5 md:px-7 rounded-2xl bg-[#2a1a1a] border border-[#5a4a2a]" data-id="element-183">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 bg-brand-red/20 rounded-lg flex items-center justify-center text-brand-red font-black text-lg md:text-xl" data-id="element-184">
                ✕
              </div>
              <p className="text-base sm:text-lg md:text-xl text-white/90 font-semibold leading-snug" data-id="element-185">
                {point}
              </p>
            </div>)}
        </div>
        <div className="text-center px-4" data-id="element-186">
          <p className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold leading-tight italic text-[#FF4D33]" data-id="element-187">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </p>
        </div>
      </div>
    </section>;
}